export default {
      id: "info_url-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#info_url-usage",
      toString: function () {
        return this.url;
      }
    }